const foodData = [
  {
    "id": 1,
    "name": "Fraise",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Fraise",
    "reveal": "Fraise",
    "alternatives": ["fraises"],
  },
  {
    "id": 2,
    "name": "Rhubarbe",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "hiver",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 1,
    "pointsFourthSeason": 0,
    "image": "Rhubarbe",
    "reveal": "Rhubarbe",
    "alternatives": ["rhubarbes"],
  },
  {
    "id": 3,
    "name": "Cerises",
    "season": "printemps",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Cerises",
    "reveal": "Cerises",
    "alternatives": ["Cerise"],
  },
  {
    "id": 4,
    "name": "Melon",
    "season": "été",
    "secondSeason": "automne",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Melon",
    "reveal": "Melon",
    "alternatives": ["Melons"],
  },
  {
    "id": 5,
    "name": "Mirabelles",
    "season": "été",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Mirabelles",
    "reveal": "Mirabelles",
    "alternatives": ["Mirabelle"],
  },
  {
    "id": 6,
    "name": "Abricots",
    "season": "été",
    "secondSeason": "automne",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Abricots",
    "reveal": "Abricots",
    "alternatives": ["Abricot"],
  },
  {
    "id": 7,
    "name": "Pomme",
    "season": "automne",
    "secondSeason": "hiver",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Pomme",
    "reveal": "Pomme",
    "alternatives": ["Pommes"],
  },
  {
    "id": 8,
    "name": "Figue",
    "season": "automne",
    "secondSeason": "été",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Figue",
    "reveal": "Figue",
    "alternatives": ["Figues"],
  },
  {
    "id": 9,
    "name": "Raisin",
    "season": "automne",
    "secondSeason": "été",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Raisins",
    "reveal": "Raisins",
    "alternatives": ["Raisins"],
  },
  {
    "id": 10,
    "name": "Kiwi",
    "season": "hiver",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Kiwi",
    "reveal": "Kiwi",
    "alternatives": ["Kiwis"],
  },
  {
    "id": 11,
    "name": "Orange",
    "season": "hiver",
    "secondSeason": "",
    "thirdSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Orange",
    "reveal": "Orange",
    "alternatives": ["Oranges"],
  },
  {
    "id": 12,
    "name": "Banane",
    "season": "hiver",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "fourthSeason": 0,
    "image": "Banane",
    "reveal": "Banane",
    "alternatives": ["Bananes"],
  },
  {
    "id": 13,
    "name": "Radis",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Radis",
    "reveal": "Radis",
    "alternatives": ["Radi"],
  },
  {
    "id": 14,
    "name": "Asperges",
    "season": "printemps",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Asperges",
    "reveal": "Asperges",
    "alternatives": ["Asperge"],
  },
  {
    "id": 15,
    "name": "Petits pois",
    "season": "printemps",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Petits Pois",
    "reveal": "Petits Pois",
    "alternatives": ["Petit Poi", "Petits Pois", "Petit Pois", "Petits Poi"],
  },
  {
    "id": 16,
    "name": "Courgette",
    "season": "été",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Courgette",
    "reveal": "Courgette",
    "alternatives": ["Courgettes"],
  },
  {
    "id": 17,
    "name": "Haricots verts",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Haricots Verts",
    "reveal": "Haricots Verts",
    "alternatives": ["Haricot Vert", "Haricots Vert", "Haricot Verts"],
  },
  {
    "id": 18,
    "name": "Tomate",
    "season": "été",
    "secondSeason": "automne",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Tomate",
    "reveal": "Tomate",
    "alternatives": ["Tomates"],
  },
  {
    "id": 19,
    "name": "Potiron",
    "season": "automne",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Potiron",
    "reveal": "Potiron",
    "alternatives": ["Potirons"],
  },
  {
    "id": 20,
    "name": "Christophine",
    "season": "automne",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Christophine",
    "reveal": "Christophine",
    "alternatives": ["Christophines"],
  },
  {
    "id": 21,
    "name": "Champignons",
    "season": "automne",
    "secondSeason": "été",
    "thirdSeason": "printemps",
    "fourthSeason": "",
    "pointsSeason": 3,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 0,
    "image": "Champignons",
    "reveal": "Champignons",
    "alternatives": ["Champignon"],
  },
  {
    "id": 22,
    "name": "Poireau",
    "season": "hiver",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Poireau",
    "reveal": "Poireau",
    "alternatives": ["Poireaux", "Poireaus"],
  },
  {
    "id": 23,
    "name": "Carotte",
    "season": "hiver",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Carotte",
    "reveal": "Carotte",
    "alternatives": ["Carottes"],
  },
  {
    "id": 24,
    "name": "Chou",
    "season": "hiver",
    "secondSeason": "",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Chou",
    "reveal": "Chou",
    "alternatives": ["Choux", "Chous"]
  },
  {
    "id": 25,
    "name": "Chèvre",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "automne",
    "fourthSeason": "hiver",
    "pointsSeason": 3,
    "pointsSecondSeason": 3,
    "pointsThirdSeason": 1,
    "pointsFourthSeason": 1,
    "image": "Chèvre Frais",
    "reveal": "Chèvre Frais",
    "alternatives": ["Chèvre Frais", "Chèvres Frais", "Chèvres", "Chevre", "Chevres"]
  },
  {
    "id": 26,
    "name": "Maroilles",
    "season": "hiver",
    "secondSeason": "printemps",
    "thirdSeason": "été",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Maroilles",
    "reveal": "Maroilles",
    "alternatives": ["Maroualle", "Marouale", "Maroille"]
  },
  {
    "id": 27,
    "name": "Camembert",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 3,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Camembert",
    "reveal": "Camembert",
    "alternatives": ["Camemberts"]
  },
  {
    "id": 28,
    "name": "Beaufort",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 1,
    "pointsSecondSeason": 3,
    "pointsThirdSeason": 1,
    "pointsFourthSeason": 3,
    "image": "Beaufort D'été",
    "reveal": "Beaufort D'été",
    "alternatives": ["Beaufort été", "Beauforts", "Beaufort d été"]
  },
  {
    "id": 29,
    "name": "St Nectaire",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 3,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "St Nectaire",
    "reveal": "St Nectaire",
    "alternatives": ["Saint Nectaire", "StNectaire", "SaintNectaire", "Saint-Nectaire", "St-Nectaire"]
  },
  {
    "id": 30,
    "name": "Munster",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Munster",
    "reveal": "Munster",
    "alternatives": ["Monster", "Munstere", "Munsters"]
  },
  {
    "id": 31,
    "name": "Chabichou",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "automne",
    "fourthSeason": "hiver",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 2,
    "image": "Chabichou Sec",
    "reveal": "Chabichou Sec",
    "alternatives": ["Chabichoux"]
  },
  {
    "id": 32,
    "name": "Tomme",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "automne",
    "fourthSeason": "hiver",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Tomme Jeune",
    "reveal": "Tomme Jeune",
    "alternatives": ["Tomme jeune", "Tomme Jeune"]
  },
  {
    "id": 33,
    "name": "Roquefort",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Roquefort",
    "reveal": "Roquefort",
    "alternatives": ["Roqueforts"]
  },
  {
    "id": 34,
    "name": "Comté",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 3,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 3,
    "image": "Comté",
    "reveal": "Comté",
    "alternatives": ["Comte", "Compté", "Conté", "Comtés", "Comptés", "Contés"]
  },
  {
    "id": 35,
    "name": "Ossau iraty",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 1,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 1,
    "image": "Ossau Iraty",
    "reveal": "Ossau Iraty",
    "alternatives": ["Ossau-Iraty", "Ossau irati", "Osso iraty"]
  },
  {
    "id": 36,
    "name": "Raclette",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 1,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 1,
    "image": "Raclette",
    "reveal": "Raclette",
    "alternatives": ["Raclett", "Raclette fromage", "Raclettes", "Fromage Raclette"]
  },
  {
    "id": 37,
    "name": "Agneau",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Agneau",
    "reveal": "Agneau",
    "alternatives": ["Agnau", "Agnaux", "Agneaux"]
  },
  {
    "id": 38,
    "name": "Canard",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 2,
    "image": "Canard",
    "reveal": "Canard",
    "alternatives": ["Canards", "Canar", "Canart"]
  },
  {
    "id": 39,
    "name": "Crabe",
    "season": "printemps",
    "secondSeason": "été",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Crabe",
    "reveal": "Crabe",
    "alternatives": ["Crabes", "Krabe", "Krabes"]
  },
  {
    "id": 40,
    "name": "Veau",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 2,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Veau",
    "reveal": "Veau",
    "alternatives": ["Veaux", "Vau", "Vaux"]
  },
  {
    "id": 41,
    "name": "Moules",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 1,
    "pointsFourthSeason": 1,
    "image": "Moules",
    "reveal": "Moules",
    "alternatives": ["Moule"]
  },
  {
    "id": 42,
    "name": "Turbot",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 4,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Turbot",
    "reveal": "Turbot",
    "alternatives": ["Turbo", "Turbeau", "Turbos", "Turbots"]
  },
  {
    "id": 43,
    "name": "Boeuf",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Boeuf",
    "reveal": "Boeuf",
    "alternatives": ["Beuf", "Boeufs", "Beufs"]

  },
  {
    "id": 44,
    "name": "Seiche",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "automne",
    "fourthSeason": "hiver",
    "pointsSeason": 0,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 2,
    "image": "Seiche",
    "reveal": "Seiche",
    "alternatives": ["Sèche", "Seche", "Seiches", "Sèches", "Seches"]

  },
  {
    "id": 45,
    "name": "Thon",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 1,
    "pointsSecondSeason": 1,
    "pointsThirdSeason": 1,
    "pointsFourthSeason": 3,
    "image": "Thon",
    "reveal": "Thon",
    "alternatives": ["Thons", "Ton", "Thons"]
  },
  {
    "id": 46,
    "name": "Dinde",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 2,
    "image": "Dinde",
    "reveal": "Dinde",
    "alternatives": ["Dind", "Dindes", "Dinde rôtie"]
  },
  {
    "id": 48,
    "name": "Huîtres",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Huitre",
    "reveal": "Huitre",
    "alternatives": ["Huitre", "Huitres", "Huître"]
  },
  {
    "id": 49,
    "name": "Fèves",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "",
    "fourthSeason": "",
    "pointsSeason": 1,
    "pointsSecondSeason": 4,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Fèves",
    "reveal": "Fèves",
    "alternatives": ["Feves", "Fève", "Feve", "Fêve", "Fêves"]
  },
  {
    "id": 50,
    "name": "Pâtes",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Pates",
    "reveal": "Pates",
    "alternatives": ["Pate", "Pates", "Pâte"]
  },
  {
    "id": 51,
    "name": "Pain",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Pain",
    "reveal": "Pain",
    "alternatives": ["Pains"]
  },
  {
    "id": 52,
    "name": "Pommes de terre",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 3,
    "pointsFourthSeason": 2,
    "image": "Pommes de Terre Nouvelles",
    "reveal": "Pommes de Terre Nouvelles",
    "alternatives": ["Pommes de Terre", "Patate", "Pomme de Terres", "Pomme de terre", "Pomme de Terre"]
  },
  {
    "id": 53,
    "name": "Lentilles",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 3,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Lentilles",
    "reveal": "Lentilles",
    "alternatives": ["Lentille"]
  },
  {
    "id": 54,
    "name": "Blé",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 1,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 4,
    "image": "Blé",
    "reveal": "Blé",
    "alternatives": ["Blés", "Ble"]
  },
  {
    "id": 55,
    "name": "Topinambour",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 0,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 1,
    "pointsFourthSeason": 4,
    "image": "Topinambour",
    "reveal": "Topinambour",
    "alternatives": ["Topinanbour", "Topinambourre", "Topinambours", "Topinanbourre", "Topinamboure"]
  },
  {
    "id": 56,
    "name": "Haricots blancs",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 4,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 0,
    "pointsFourthSeason": 0,
    "image": "Haricots Blancs Demi Secs",
    "reveal": "Haricots Blancs Demi Secs",
    "alternatives": ["Haricot Blancs", "Haricots blanc", "Haricot blanc", "haricot blanc"]
  },
  {
    "id": 57,
    "name": "Riz",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "automne",
    "fourthSeason": "hiver",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Riz",
    "reveal": "Riz",
    "alternatives": ["Rit"]
  },
  {
    "id": 58,
    "name": "Patate douce",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 0,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 4,
    "pointsFourthSeason": 1,
    "image": "Patate Douce",
    "reveal": "Patate Douce",
    "alternatives": ["PatateDouce", "Patates Douces", "Patate Douces", "Patates Douce"]
  },
  {
    "id": 59,
    "name": "Semoule",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 2,
    "pointsSecondSeason": 2,
    "pointsThirdSeason": 2,
    "pointsFourthSeason": 2,
    "image": "Semoule",
    "reveal": "Semoule",
    "alternatives": ["Semoules"]
  },
  {
    "id": 60,
    "name": "Butternut",
    "season": "été",
    "secondSeason": "printemps",
    "thirdSeason": "hiver",
    "fourthSeason": "automne",
    "pointsSeason": 0,
    "pointsSecondSeason": 0,
    "pointsThirdSeason": 4,
    "pointsFourthSeason": 1,
    "image": "Butternut",
    "reveal": "Butternut",
    "alternatives": ["Buternut", "Butternutt", "Buternutt"]
  },
];


export default foodData;